// extracted by mini-css-extract-plugin
export default {"recipientsPreview":"esZhRFBA3MY3W_nm8Giy","MuiSvgIcon-root":"qFR0CupOPSRqPVevZYgz"};